module.exports = __webpack_public_path__ + "img/mickey65.fbd81cff.jpg";